/* Yotpo Spotlight Drawer localisation.
   1) Reward titles that are only an amount or a percentage get the discount word of the page language:
      DE: "50 €" -> "50 € Rabatt"   "10%" -> "10% Rabatt"
      FR: "50 €" -> "50 € de réduction"
      EN: "50 €" -> "50 € off"
      Titles with other words (e.g. "10% off Birthday Coupon") and titles starting with "-" are left alone.
   2) Points expiry date: Yotpo always prints English month names / US order ("Dec 3, 2026", "12/20/2026")
      DE: "3. Dez. 2026"   FR: "3 déc. 2026"   EN: left as Yotpo renders it. */
(function () {
  var lang = (document.documentElement.lang || 'de').slice(0, 2);
  var WORDS = { de: 'Rabatt', fr: 'de réduction', en: 'off' };
  var word = WORDS[lang];

  var RE_VALUE = /^\s*(?:€\s*\d+(?:[.,]\d+)?|\d+(?:[.,]\d+)?\s*(?:€|%))\s*$/;

  var MONTHS = { jan: 0, feb: 1, mar: 2, apr: 3, may: 4, jun: 5, jul: 6, aug: 7, sep: 8, oct: 9, nov: 10, dec: 11 };
  var RE_DATE_TEXT = /\b(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)[a-z]*\.?\s+(\d{1,2}),?\s+(\d{4})\b/;
  var RE_DATE_NUMERIC = /\b(\d{1,2})\/(\d{1,2})\/(\d{4})\b/;
  var formatter = new Intl.DateTimeFormat(lang, { day: 'numeric', month: 'short', year: 'numeric', timeZone: 'UTC' });

  function fixTitle(el) {
    var text = el.textContent;
    if (word && RE_VALUE.test(text)) el.textContent = text.trim() + ' ' + word;
  }

  function fixDates(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var value = node.nodeValue;
      var next = value.replace(RE_DATE_TEXT, function (all, mon, d, y) {
        return formatter.format(new Date(Date.UTC(+y, MONTHS[mon.toLowerCase()], +d)));
      }).replace(RE_DATE_NUMERIC, function (all, m, d, y) {
        return formatter.format(new Date(Date.UTC(+y, +m - 1, +d)));
      });
      if (next !== value) node.nodeValue = next;
    }
  }

  var scheduled = false;
  function run() {
    scheduled = false;
    document.querySelectorAll('.yotpo-spotlight-reward__title').forEach(fixTitle);
    if (lang !== 'en') document.querySelectorAll('.yotpo-spotlight-drawer__points-card').forEach(fixDates);
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(run);
  }

  function start() {
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
    schedule();
  }

  if (document.body) start();
  else document.addEventListener('DOMContentLoaded', start);
})();